import { apiSlice } from "./apiSlice";
import totalOrder from "../assets/totalOrder.svg";
import totalSales from "../assets/totalSales.svg";
import returnedOrder from "../assets/returnedOrder.svg";
import totalCustomer from "../assets/totalCustomer.svg";
import transaction from "../assets/transaction.svg";
import sales from "../assets/sales.svg";
import profileVerification from "../assets/profileVerification.svg";
import cancellation from "../assets/Cancelation.svg";
import refund from "../assets/refund.svg";

export const homeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSalesSummary: builder.query({
      query: () => "/dashboard/sales-summary",
      transformResponse: (response) => {
        if (!response?.data) {
          return {
            earning_summary: [],
            sales_summary: [],
          };
        }

        const { earning_summary = [], sales_summary = [] } = response.data;

        const imageMap = [transaction, sales];
        const transformedEarningSummary = earning_summary.map(
          (item, index) => ({
            ...item,
            id: index + 1,
            image: imageMap[index],
          })
        );

        return {
          ...response.data,
          earning_summary: transformedEarningSummary,
          sales_summary: sales_summary,
        };
      },
      providesTags: ["SalesSummary"], // 👈 added
    }),

    getOrderSummary: builder.query({
      query: () => "/dashboard/order-summary",
      transformResponse: (response) => {
        if (!response.data || !Array.isArray(response.data)) {
          return [];
        }
        const imageMap = [totalOrder, totalSales, returnedOrder, totalCustomer];
        return response.data.map((item, index) => ({
          ...item,
          id: index + 1,
          image: imageMap[index],
        }));
      },
      providesTags: ["OrderSummary"], // 👈 added
    }),

    getProfilePaymentSummary: builder.query({
      query: () => "/dashboard/profile-payment-summary",
      transformResponse: (response) => {
        if (!response.data || !Array.isArray(response.data)) {
          return [];
        }

        const config = [
          { image: profileVerification, path: "retailers" },
          { image: sales, path: "orders" },
          { image: cancellation, path: "cancellations?status=0" },
          { image: refund, path: "refunds" },
        ];

        return response.data.map((item, index) => ({
          ...item,
          id: index + 1,
          ...(config[index] || {}),
        }));
      },
      providesTags: ["ProfilePaymentSummary"], // 👈 added
    }),
  }),
});

// Export the generated hooks
export const {
  useGetSalesSummaryQuery,
  useGetOrderSummaryQuery,
  useGetProfilePaymentSummaryQuery,
} = homeApiSlice;
